// (TF3-3) a video made by the retired legacy pipeline (no run): its script, storyboard and render steps are gone — the
// backend answers 410 for them. It can still be opened, watched and downloaded on its own page.
import { useNavigate } from "react-router-dom";
import { PageContainer, TfCard, Btn, EmptyState } from "@/components/v2/primitives.tsx";

export function RetiredLegacyVideo({ videoId }: { videoId: string }) {
  const navigate = useNavigate();
  return (
    <PageContainer>
      <TfCard>
        <EmptyState icon="video" title="This video was made by our previous pipeline"
          sub="Its script, storyboard and render steps are no longer available. You can still open the video, watch it and download it. New videos are made by our current pipeline."
          action={<Btn onClick={() => navigate(`/videos/${videoId}`)}>Open the video</Btn>} />
      </TfCard>
    </PageContainer>
  );
}
